export const CLOSE_DRAWER_MENU = 'CLOSE_DRAWER_MENU';
declare global {
  interface DocumentEventMap {
    [CLOSE_DRAWER_MENU]: CustomEvent<boolean>;
  }
}

export function closeMenuDrawer() {
  const event = new CustomEvent(CLOSE_DRAWER_MENU);
  document.body.dispatchEvent(event);
}
